import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Button from '../Button/Button.jsx';
import Form from './Form.jsx';
import './ModalForm.css';

export default function ModalForm({
  triggerText = 'Связаться с нами',
  requestType = 'Связаться с нами',
  messagePrefix = '',
  submitText = triggerText,
  successText = 'Сообщение отправлено',
  triggerClassName = '',
}) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleEscape = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };

    document.addEventListener('keydown', handleEscape);
    document.body.classList.add('modal-open');

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.classList.remove('modal-open');
    };
  }, [isOpen]);

  return (
    <>
      <div className={`modal_form_trigger ${triggerClassName}`.trim()}>
        <Button onClick={() => setIsOpen(true)}>{triggerText}</Button>
      </div>

      {isOpen && createPortal(
        <div className="modal_form_overlay" onClick={() => setIsOpen(false)} role="presentation">
          <div className="modal_form_content" onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true" aria-label={triggerText}>
            <button type="button" className="modal_form_close" onClick={() => setIsOpen(false)} aria-label="Закрыть форму">×</button>
            <Form
              requestType={requestType}
              messagePrefix={messagePrefix}
              submitText={submitText}
              successText={successText}
            />
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
